module.exports = __webpack_public_path__ + "static/img/003.fb675c4e.png";